module.exports = __webpack_public_path__ + "media/images/contents/questionnaires/template_pattern_2-0449bcd58a3e470b6ab403dffa316509.png";